module.exports = __webpack_public_path__ + "img/05-trpg-material2021.0fd68abb.png";